import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef } from '@shared/port-v1.0.0'

import Comp from '../component'

export type Props = BaseReactProps & {}

export default {
	module: { static: Comp },
	inNode: {
		inputs: [getPortDef({ name: 'opacity', displayName: 'Opacity', group: 'Styles', type: 'number', default: 1 })],
	},
} satisfies ReactNodeDef
